/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_Filter_Missing_KeyInputs */



/**
* | output |
* | --- |
* | "Every value needs a field name." |
*
* @param {Agent_Event_Trigger_Filter_Missing_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_filter_missing_key = /** @type {((inputs?: Agent_Event_Trigger_Filter_Missing_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_Filter_Missing_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jeder Wert braucht einen Feldnamen.")
	return /** @type {LocalizedString} */ ("Every value needs a field name.")
});